import {
  REQUEST_REPORT_FORMATS,
  RESPONSE_REPORT_FORMATS,
  REQUEST_REPORT_FORMATS_FAILURE
} from '../actions/reportFormatsActions'

import { states } from './queriesStates'

const initialState = {
  dataState: states.NOT_REQUESTED,
  data: [],
  errors: []
}

const reportFormatsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_REPORT_FORMATS:
      return Object.assign(
        {},
        state,
        {
          dataState: states.REQUEST
        }
      )
    case RESPONSE_REPORT_FORMATS:
      return Object.assign(
        {},
        state,
        {
          dataState: states.READY,
          data: action.data
        }
      )
    case REQUEST_REPORT_FORMATS_FAILURE:
      return Object.assign(
        {},
        state,
        {
          dataState: states.FAILURE,
          errors: action.errors
        }
      )
    default:
      return state
  }
}

export default reportFormatsReducer